import React from 'react';
import { IProps as IBlockProps } from '@/blocks/ComposableContentBlock/ComposableContentBlock.interface';
import { ComposableContentBlock } from './ComposableContentBlock.component';

import TranslationComponent from '@/utils/TranslationComponent/TranslationComponent';

export interface IBlockInputProps {
    parentClass?: string;
    title?: string;
    anchorId?: string;
    columns?: any;
    apiUrl?: string;
    cta?: any;
    ctaType?: any;
    hasSearch?: boolean;
    placeholder?: string;
    hasCategory?: boolean;
    categories?: any;
    noResultMessage?: string;
    noMoreContentMessage?: string;
    // [key: string]: any;
}

const mapInputToProps = (input: IBlockInputProps): IBlockProps => {
    const {
        parentClass,
        anchorId,
        title,
        columns,
        cta,
        ctaType,
        categories,
        hasCategory,
        hasSearch,
        placeholder,
        noResultMessage,
        noMoreContentMessage,
        apiUrl,
        ...rest
    } = input;
    return {
        title,
        columns,
        apiUrl: apiUrl || '',
        buttonText: cta?.text || 'More',
        hasSearch,
        placeholder,
        hasCategory,
        categories,
        noResultMessage,
        noMoreContentMessage: noMoreContentMessage || '',
        ...rest, // Pass through BlockWrapper related settings
    };
};

const BlockTranslation: React.FC<IBlockInputProps> = (inputProps) => {
    return (
        <TranslationComponent
            inputProps={inputProps}
            TargetComponent={ComposableContentBlock}
            mapProps={mapInputToProps}
        />
    );
};

export default BlockTranslation;
